export const FLIGHT_PLANNER_BASE_URL = import.meta.env.VITE_FLIGHT_PLANNER_BASE_URL;

export const CONTENT_TYPE_JSON = 'application/json';
